// src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import supabase from '../supabase';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  // Environment variable for redirect
  // Locally: .env => REACT_APP_SUPABASE_REDIRECT_URL=http://localhost:3000/reset
  // Prod: in Vercel => REACT_APP_SUPABASE_REDIRECT_URL=https://islike.com/reset
  const redirectURL =
    process.env.REACT_APP_SUPABASE_REDIRECT_URL || 'http://localhost:3000/reset';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      // Use supabase to send a password-reset email
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: redirectURL,
      });
      if (error) {
        throw new Error(error.message);
      }
      setMessage('Check your email for a reset link.');
    } catch (err) {
      setMessage(`Error: ${err.message}`);
    }
  };

  return (
    <div style={{ marginTop: '1rem' }}>
      <h2>Forgot Password</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="email">Enter your email:</label>
        <br />
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ margin: '0.5rem 0' }}
        />
        <br />
        <button type="submit">Reset Password</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default ForgotPassword;
